import React, { useState } from "react";
import HackSidebar from "./HackSidebar";
import { FiMenu } from "react-icons/fi";
import logo from "../assets/astra_hack_logo.png";

const HackLayout = ({ children, activeId }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="bg-background min-h-screen flex selection:bg-primary selection:text-white">
      <HackSidebar
        showSidebar={showSidebar}
        onSidebarHide={() => setShowSidebar(false)}
        activeId={activeId}
      />

      <div className="min-h-screen bg-background text-white lg:pl-64 w-full">
        {/* Mobile Top Bar */}
        <div className="lg:hidden p-4 flex items-center justify-between border-b border-white/10 bg-surface/50 backdrop-blur-md sticky top-0 z-40">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-primary to-secondary p-[1px]">
              <div className="w-full h-full rounded-full bg-background overflow-hidden relative">
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
              </div>
            </div>
            <span className="font-bold text-primary">AstraHack</span>
          </div>
          <button
            onClick={() => setShowSidebar(true)}
            className="p-2 text-text-muted hover:text-white transition-colors"
          >
            <FiMenu size={24} />
          </button>
        </div>

        <div className="w-full p-4 md:p-10">{children}</div>
      </div>
    </div>
  );
};

export default HackLayout;
